import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import blogRepository from '../../repositories/blog/blogRepository';
import mediaRepository from '../../repositories/general/mediaRepository';

const dataBlog = {
  title: null,
  image: null,
  image_collect: [],
  content: null,
  list_media: [],
  list_media_collect: [],
};

export const useBlogStore = defineStore('blogStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataBlog),
    hasFormError: structuredClone(dataBlog),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataBlog = await blogRepository.getData(params);
        if (dataBlog.data.status === 200) {
          this.listData = dataBlog.data.data.blog.list;
          this.pagination = dataBlog.data.data.blog.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveBlog = await blogRepository.saveData(params);
        if (saveBlog.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        blog_id: id,
      };
      const dataDetailBlog = await blogRepository.getDataDetail(params);

      if (dataDetailBlog.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailBlog.data.data;

        this.formData.title = data.title;
        this.formData.content = data.desc;
        this.formData.image = data.image.file_id;
        this.formData.image_collect = data.image;

        data.list_media.forEach((item) => {
          this.formData.list_media.push(item.file_id);
          this.formData.list_media_collect.push(item);
        });
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          blog_id: id,
          ...this.formData,
        };
        const updateBlog = await blogRepository.updateData(params);
        if (updateBlog.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          blog_id: id,
        };
        const deleteBlog = await blogRepository.deleteData(params);
        if (deleteBlog.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    async uploadFile(file, type) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const uploadFile = await mediaRepository.uploadFile(file);
        if (uploadFile.data.status === 200) {
          this.isSuccess = true;
          if (type === 'MAIN_IMAGE') {
            this.formData.image = uploadFile.data.data.file_id;
            this.formData.image_collect = uploadFile.data.data;
          } else if (type === 'GALLERY_IMAGE') {
            this.formData.list_media.push(uploadFile.data.data.file_id);
            this.formData.list_media_collect.push(uploadFile.data.data);
          }
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
        this.setFormError(error.response.data.error);
      } finally {
        this.isLoadingForm = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataBlog);
      }
      this.hasFormError = structuredClone(dataBlog);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useBlogStore, import.meta.webpackHot));
}
